import { CommonModule } from '@angular/common';
import { Component, computed, effect, signal } from '@angular/core';

// EZ
import { EzBaseComponent, EzFormInputType, InputConfig, TabConfig } from "@template-ui";
import { UiLibraryModule } from '@template-ui/template-ui.module';
import { DocMeta } from "@template-ui/decorators";
import { EzPanelSampleComponent } from "../Panel/Simple/EzPanelSampleComponent.sample";
import { SimplePanelHeaderSample } from "../Panel/SimplePanelHeader.sample/SimplePanelHeaderSample.sample";
import { EzSectionSampleComponent } from "../Section/ez-section-sample.component";

@DocMeta({
  hide: true,
  showcaseTitle: "Hide and disable",
  showcaseDesc: "Use the checkboxes to hide or disable a tab. It's all done with signals"
})
@Component({
    selector: 'ui-tab-group-sample1, ez-tab-group-sample1',
    templateUrl: './ez-tab-group-sample1.component.html',
    styleUrl: './ez-tab-group-sample1.component.scss',
    imports: [
        CommonModule,
        UiLibraryModule
    ]
})
export class EzTabGroupSample1Component extends EzBaseComponent
{

  formConfig: InputConfig[] = [

    {
      type: EzFormInputType.CHECKBOX,
      label: "Hide 2nd Tab",
      name: "hide"
    },
    {
      type: EzFormInputType.CHECKBOX,
      label: "Disable 3rd Tab",
      name: "disable"
    }
  ];

  formValues = signal({
    hide: false,
    disable: false
  })

    tabs: TabConfig[] = [
    {
      label: 'Panel',
      fragment: 'panel',
      component: EzPanelSampleComponent,
    },
    {
      label: 'Panel Header',
      fragment: 'panel-header',
      component: SimplePanelHeaderSample ,
      hidden: computed(() => this.formValues()['hide'])
    },
    {
      label: 'Section',
      fragment: 'section',
      component: EzSectionSampleComponent,
      disabled: computed(() => this.formValues()['disable'])
    }
  ];

  constructor()
  {
    super();

    this.thisClassName = "EzTabGroupSample1Component testing";
    this.dlogEnabled = true;

    this.dlog("EzTabGroupSample1Component constructor, is the class name correct?");

    effect(() => {
      // Do stuff that must wait for a signal, like cdcNum or caseId
    })
  }

  // Called once after the first @Input() values are set
  // Use this for initialization logic (fetch data, set defaults)
  ngOnInit() {}

  // Called once after the component’s view (and child views) are initialized
  // Use this for DOM-dependent logic. i.e. a component exists inside an an *ngIf.
  override ngAfterViewInit(): void
  {
    super.ngAfterViewInit();
  }

}
